/**
 * Slider de catégories (Ge-Ro) — section « Nos produits promotionnels ».
 *
 * Swiper est chargé en global (swiper-bundle) via init_swiper() côté PHP
 * (bloc category-slider → render() appelle init_swiper).
 */
function initCategorySliders() {
  const sliders = document.querySelectorAll('.category-swiper');
  if (!sliders.length || typeof window.Swiper === 'undefined') {
    return false;
  }

  sliders.forEach((el) => {
    if (el.dataset.swiperInit) return;
    el.dataset.swiperInit = '1';

    const root = el.closest('.category-slider') || document;

    new window.Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 32,
      speed: 500,
      navigation: {
        prevEl: root.querySelector('.cat-prev'),
        nextEl: root.querySelector('.cat-next'),
      },
      breakpoints: {
        640: { slidesPerView: 2 },
        900: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
      },
    });
  });

  return true;
}

function boot() {
  if (!initCategorySliders()) {
    window.addEventListener('load', initCategorySliders, { once: true });
  }
}

if (document.readyState !== 'loading') {
  boot();
} else {
  document.addEventListener('DOMContentLoaded', boot);
}
